import { BaseService } from 'core/services';
import LookupRouteService from './LookupRouteService';

class LookupService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LookupRouteService());
    }

    async getLookups(resource){
        const url = this.routeService.getLookups(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async syncNikoPriceGroups(){
        const url = this.routeService.syncNikoPriceGroups(); 
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
}

export default LookupService;
